import { render, staticRenderFns } from "./UserNavigation.vue?vue&type=template&id=0a98a103&"
import script from "./UserNavigation.vue?vue&type=script&lang=ts&"
export * from "./UserNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Btn: require('/vercel/path0/components/Btn.vue').default,Modal: require('/vercel/path0/components/Modal.vue').default})
